export default __webpack_public_path__ + "static/media/Settings.64c09861.jpg";